import cn from 'clsx';

import classes from './chat-bubble.module.css';

export type ChatBubbleProps = React.PropsWithChildren<{
  type: 'sent' | 'received';
  className?: string | undefined;
}>;

export function ChatBubble({ type, className, children }: ChatBubbleProps) {
  return (
    <div
      className={cn(
        classes.shared,
        className,
        type === 'sent' ? classes.sent : classes.received,
        type === 'sent' ? 'sent' : 'received',
      )}
    >
      {children}
    </div>
  );
}
